import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	shareFormTitle: {
		id: 'horizontal-nav-header.common.share-button.share-form-title',
		defaultMessage: 'Share',
		description: 'Title of a form to share the project or board',
	},
	shareHelperMessage: {
		id: 'horizontal-nav-header.common.share-button.share-helper-message',
		defaultMessage: 'This view, along with any applied groups and filters are shared',
		description:
			'Message indicating the recipients of the email share will be able to see other tab views as well',
	},
});
